export default __webpack_public_path__ + "static/media/view4_month_place_cause_.285505db.csv";